/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Commandautomate1Inputs */



/**
* | output |
* | --- |
* | "Controller command" |
*
* @param {Ahu_History_Key_Commandautomate1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_commandautomate1 = /** @type {((inputs?: Ahu_History_Key_Commandautomate1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Commandautomate1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Controller command")
	return /** @type {LocalizedString} */ ("Commande automate")
});
export { ahu_history_key_commandautomate1 as "ahu_history_key_commandAutomate" }